import Vue from 'vue';
import language from '@/components/language';

Vue.component('lang', language);
